import { WebPubSubClient } from '@azure/web-pubsub-client';

// Wraps the WebPubSubClient with the only behaviours the widget needs:
// connect via the access URL returned from startVirtualAgentSession,
// subscribe to inbound group/server messages, and shut down cleanly.

export type PubSubHandler = (data: any) => void;

export class WidgetTransport {
  private client: WebPubSubClient | null = null;
  private handler: PubSubHandler = () => {};
  private stopped = false;

  onMessage(fn: PubSubHandler): void {
    this.handler = fn;
  }

  async connect(accessUrl: string): Promise<void> {
    this.stopped = false;
    const client = new WebPubSubClient(accessUrl);
    client.on('group-message', (e: any) => {
      const data = e?.message?.data;
      this.dispatch(data);
    });
    client.on('server-message', (e: any) => {
      const data = e?.message?.data;
      this.dispatch(data);
    });
    await client.start();
    this.client = client;
  }

  private dispatch(data: any): void {
    if (this.stopped) return;
    if (typeof data === 'string') {
      try { this.handler(JSON.parse(data)); }
      catch { /* non-JSON server frames are ignored */ }
    } else if (data && typeof data === 'object') {
      this.handler(data);
    }
  }

  async stop(): Promise<void> {
    this.stopped = true;
    const c = this.client;
    this.client = null;
    if (c) {
      try { await c.stop(); } catch { /* swallow */ }
    }
  }
}
